import router from "@/router";

export const useHelper = () => {
  const navigateToShow = (slug = null, type = "seating") => {
    router.push(`/${slug}/${type}`);
  };

  return {
    navigateToShow,
  };
};
